import React from 'react'

const Plan = () => <div className="Container">
    <h1>2024</h1>
    <span>Black Tracks Gnistra ska förhoppningsvis få en kull under året. Kommer uppdatera med mer information efter parning. Förhoppningsvis sommarvalpar men beror på när löp kommer.</span>
</div>

export default Plan;